import React from "react";
import TransferShipment from "./TransferShipment";

const TransferInventoryStep2 = () => <TransferShipment />;

export default TransferInventoryStep2;
